import React, { useEffect, useMemo } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import ImageSlide from "./ImageSlide";
import VideoSlide from "./VideoSlide";
import ModalVideoSlide from "./ModalVideoSlide";

import { useSynchronizedState } from "@solidwhite/multiuser";

type CarouselProps = {
  data: any[];
  playIconBackgroundColor: string;
  playIconBorderColor: string;
  showIndicators?: boolean;
  id: string;
};

export const CarouselComponent: React.FunctionComponent<CarouselProps> = (props: CarouselProps) => {
  const { data, playIconBackgroundColor, playIconBorderColor, showIndicators = true, id } = props;

  const [currentSlide, setCurrentSlide] = useSynchronizedState(`Carousel_${id}`, 0);

  useEffect(() => {
    setCurrentSlide(0);
  }, []);

  const customRenderItem = (item, props) => {
    return <item.type {...item.props} {...props} />;
  };

  const slideComponents = useMemo(() => {
    const comps: any[] = [];

    data.forEach((sc, i) => {
      if (sc.type === "videofile") {
        comps.push(<ModalVideoSlide key={sc.id} src={sc.video} thumbnail={sc.thumbnail} id={sc.id} />);
        // comps.push(
        //   <VideoSlide
        //     key={sc.id}
        //     src={sc.video}
        //     thumbnail={sc.thumbnail}
        //     playIconBackgroundColor={playIconBackgroundColor}
        //     playIconBorderColor={playIconBorderColor}
        //   />
        // );
      } else if (sc.type === "imagefile") {
        comps.push(<ImageSlide key={sc.id} src={sc.playlistfile} id={sc.id} />);
      }
    });
    return comps;
  }, [data]);

  const handleChange = (e) => {
    setCurrentSlide(e);
  };

  return (
    <Carousel
      emulateTouch
      swipeable
      useKeyboardArrows
      showStatus={false}
      showThumbs={false}
      showArrows={false}
      renderItem={customRenderItem}
      infiniteLoop={true}
      showIndicators={showIndicators}
      onChange={handleChange}
      selectedItem={currentSlide}
    >
      {slideComponents}
    </Carousel>
  );
};

const TestComp = () => {
  const random = useMemo(() => {
    return Math.floor(Math.random() * 100);
  }, []);

  return (
    <div
      style={{
        position: "relative",
        paddingTop: "56.25%", // Player ratio: 100 / (1280 / 720)
        cursor: "pointer",
        background: "green",
      }}
    >{`AAAAAAAAAA ${random}}`}</div>
  );
};
